export default class DriftApi {
    appId: string | null
    userId?: number
    isConstructed?: boolean
    isIdentified?: boolean
    isLoaded?: boolean
    isReady?: boolean

    constructor({ appId = null }: { appId?: string | null }) {
        this.appId = appId

        if (!this.appId) {
            return
        }
        if (this.isConstructed) {
            return
        }

        const scriptText = `!function() {
            var t = window.driftt = window.drift = window.driftt || [];
            if (!t.init) {
              if (t.invoked) return void (window.console && console.error && console.error("Drift snippet included twice."));
              t.invoked = !0, t.methods = [ "identify", "config", "track", "reset", "debug", "show", "ping", "page", "hide", "off", "on", "setUserAttributes" ],
              t.factory = function(e) {
                return function() {
                  var n = Array.prototype.slice.call(arguments);
                  return n.unshift(e), t.push(n), t;
                };
              }, t.methods.forEach(function(e) {
                t[e] = t.factory(e);
              }), t.load = function(t) {
                var e = 3e5, n = Math.ceil(new Date() / e) * e, o = document.createElement("script");
                o.type = "text/javascript", o.async = !0, o.crossorigin = "anonymous", o.src = "https://js.driftt.com/include/" + n + "/" + t + ".js";
                var i = document.getElementsByTagName("script")[0];
                i.parentNode.insertBefore(o, i);
              };
            }
          }();
          drift.SNIPPET_VERSION = '0.3.1';`

        const script = document.createElement('script')

        script.innerText = scriptText
        script.async = true
        document.body.appendChild(script)

        this.isConstructed = true

        this.on('ready', () => {
            this.isReady = true
        })
    }

    on(event: string, cb: Function) {
        const win: any = window

        win?.drift?.on(event, cb)
    }

    identify(userId: number, attributes?: any) {
        if (!this.isConstructed) {
            return
        }
        if (this.isIdentified) {
            return
        }

        this.userId = userId

        const win: any = window

        win?.drift?.identify(`${this.userId}`, attributes)
        this.isIdentified = true

        win?.drift?.load(`${this.appId}`)
        this.isLoaded = true
    }

    track(event: string, attributes?: any) {
        if (!this.isConstructed) {
            return
        }
        if (!this.isLoaded) {
            return
        }

        const win: any = window

        if (this.isReady) {
            win?.drift?.track(event, attributes)
        } else {
            this.on('ready', () => {
                win?.drift?.track(event, attributes)
            })
        }
    }

    page() {
        if (!this.isConstructed) {
            return
        }
        if (!this.isLoaded) {
            return
        }

        const win: any = window

        if (this.isReady) {
            win?.drift?.page()
        } else {
            this.on('ready', () => {
                win?.drift?.page()
            })
        }
    }

    show() {
        if (!this.isConstructed) {
            return
        }

        const win: any = window

        if (this.isReady) {
            win?.drift?.show()
        } else {
            this.on('ready', (api: any) => {
                api?.widget?.show()
            })
        }
    }

    hide() {
        if (!this.isConstructed) {
            return
        }

        const win: any = window

        if (this.isReady) {
            win?.drift?.hide()
        } else {
            this.on('ready', (api: any) => {
                api?.widget?.hide()
                // This timeout is a hack to workaround a bug in the Drift app
                const timeoutHide = (): void => {
                    win?.drift.hide()
                }

                setTimeout(timeoutHide, 1)
            })
        }
    }

    startInteraction(interaction: any) {
        if (!this.isConstructed) {
            return
        }

        const win: any = window

        if (this.isReady) {
            win?.drift?.startInteraction(interaction)
        } else {
            this.on('ready', (api: any) => {
                api?.startInteraction(interaction)
            })
        }
    }

    setUserAttributes(interaction: any) {
        if (!this.isConstructed) {
            return
        }

        const win: any = window

        if (this.isReady) {
            win?.drift?.setUserAttributes(interaction)
        } else {
            this.on('ready', () => {
                win?.drift?.setUserAttributes(interaction)
            })
        }
    }
}
